import React, { useRef } from 'react';
import {
    ImageWithPlaceholder,
    GalleryNext,
    GalleryNextThumbnails,
    GalleryNextThumbnail,
    GalleryNextSlides,
} from '@hpstellar/core';
import { Carousel } from '@hpstellar/core/visId';

export default ({ images, variation }) => {
    const ref = useRef();

    if (variation === 'gift-guide') {
        return (
            <div class="placeholder">
                <Carousel
                    className="preview"
                    prevArrowClassName="carouselArrows"
                    nextArrowClassName="carouselArrows"
                    showDotsCounter
                    dots
                    ref={ref}
                    arrows
                    carouselIndicatorProps={{
                        onClickDot: index => {
                            ref.current?.slickGoTo(index);
                        },
                    }}
                >
                    {images.map(({ src, alt }, i) => (
                        <ImageWithPlaceholder
                            src={src}
                            placeholderClassName="placeholderImage"
                            key={i}
                            decoding="async"
                            loading="lazy"
                            alt={alt}
                        />
                    ))}
                </Carousel>
            </div>
        );
    }

    return (
        <GalleryNext>
            <div class="thumbnails">
                <GalleryNextThumbnails orientation="vertical" className="carousel-thumbnails">
                    {images.map((image, i) => (
                        <GalleryNextThumbnail
                            className="thumbnail"
                            key={i}
                            ImageWithPlaceholderProps={{
                                src: image.src,
                                alt: image.alt,
                            }}
                        />
                    ))}
                </GalleryNextThumbnails>

                <GalleryNextSlides>
                    {images.map(({ src, alt }, i) => (
                        <div className="imageContainer">
                            <ImageWithPlaceholder
                                src={src}
                                placeholderClassName="placeholderImage"
                                key={i}
                                decoding="async"
                                loading="lazy"
                                alt={alt}
                            />
                        </div>
                    ))}
                </GalleryNextSlides>
            </div>
        </GalleryNext>
    );
};
